var exports = {
  "D": "Heading__toON9Z",
};

module.exports = exports;
